import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import rootReducer from "./root.reducer";

export function configureStore() {
  const composeEnhancers = composeWithDevTools({});

  const store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(thunkMiddleware)
    )
  )
  return store;
}



// WEBPACK FOOTER //
// ./src/store/store.ts